import React from 'react';
import styles from './ChangeTagsModal.module.scss';
import { SFButton, SFDialog } from 'sfui';
import { FieldValueType, ReportTags } from '../../../Models';
import { ChangeTags } from '../ChangeTags/ChangeTags';

export interface ChangeTagsModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  isSaveButtonDisabled: boolean;
  tags: ReportTags | undefined;
  onTagsChange: (tags: FieldValueType) => void;
  onSave: () => void;
  onDiscard: () => void;
}

export const ChangeTagsModal = ({
  isOpen,
  isLoading,
  isSaveButtonDisabled,
  tags,
  onTagsChange,
  onSave,
  onDiscard
}: ChangeTagsModalProps): React.ReactElement<ChangeTagsModalProps> => {
  return (
    <SFDialog open={isOpen} PaperProps={{ className: styles.changeTagsModal }}>
      <ChangeTags tags={tags} onTagsChange={onTagsChange} />
      <footer>
        <SFButton
          size="large"
          variant="text"
          sfColor="grey"
          onClick={onDiscard}
        >
          Discard
        </SFButton>
        <SFButton
          size="large"
          variant="contained"
          sfColor="blue"
          isLoading={isLoading}
          onClick={() => onSave()}
          disabled={isSaveButtonDisabled}
        >
          Save Changes
        </SFButton>
      </footer>
    </SFDialog>
  );
};
